import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import swal from "@sweetalert/with-react";
import Button from "../../components/Button";
import Card from "../../components/Card";
import Editor from "../../components/Editor";
import TextInput from "../../components/TextInput";
import Loader from "../../components/Loader";
import BigLoader from "../../components/BigLoader";
import { setInterface } from "../../redux/slices/interfaceSlice";
import service from "../../service";

export default function ComposeBook({ editMode = false }) {
  const dispatch = useDispatch();
  const { id, bookId } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [loadingContent, setLoadingContent] = useState(editMode);
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const _proceed = ({ title, description }) => {
    setLoading(true);
    service({
      url: editMode
        ? `/api/deep-read/${id}/books/${bookId}`
        : `/api/deep-read/${id}/books`,
      data: {
        title,
        description,
      },
      method: editMode ? "PUT" : "POST",
    })
      .then(() => {
        setLoading(false);
        swal(
          "Berhasil",
          editMode ? "Buku berhasil disunting" : "Buku telah ditambahkan",
          "success"
        ).then((value) => {
          if (value) {
            history.replace(`/deep-read/${id}/book`);
          }
        });
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    dispatch(
      setInterface({
        active: "Deep Read",
        pageTitle: editMode ? "Edit Buku" : "Tambah Buku",
      })
    );
  }, [dispatch, editMode]);

  useEffect(() => {
    if (editMode) {
      service
        .get(`/api/deep-read/${id}/books/${bookId}`)
        .then((res) => {
          const { title, description } = res.data;
          setLoadingContent(false);
          reset({
            title,
            description,
          });
        })
        .catch((err) => {
          setLoadingContent(false);
          if (err.response?.status === 404) {
            history.replace(`/deep-read/${id}/book`);
          }
        });
    }
  }, [editMode, id, bookId, history, reset]);

  if (loadingContent) {
    return (
      <div className="h-64 flex justify-center items-center flex-col">
        <Loader className="bg-black-100" />
        <span className="mt-3 text-black-300 text-sm">Memuat</span>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit(_proceed)} className="flex flex-col">
      <Helmet>
        <title>{(editMode ? "Edit" : "Tambah") + " Buku"}</title>
      </Helmet>
      <Card className="w-full">
        <TextInput
          label="Judul Buku"
          containerClassName="mb-4"
          message={errors.title?.message}
          {...register("title", { required: "Tidak boleh kosong" })}
        />
        <Controller
          name="description"
          defaultValue=""
          control={control}
          render={({ field: { onChange, value } }) => (
            <Editor
              label="Deskripsi Buku"
              containerClassName="mb-4"
              value={value}
              message={errors.description?.message}
              onChange={onChange}
            />
          )}
          rules={{ required: "Tidak boleh kosong" }}
        />
        <div className="flex gap-3">
          <Button type="submit" className="w-24">
            {editMode ? "Simpan" : "Tambah"}
          </Button>
        </div>
      </Card>
      {loading && <BigLoader />}
    </form>
  );
}
